import corporateHoliday from "./corporateHoliday.component";
import corporateHolidayUrls from "./corporateHoliday.urls";
import CorporateHolidayTransforms from "./corporateHoliday.transforms";

const corporateHolidayModule = angular
  .module("app.components.corporateHoliday", [])
  .component("corporateHolidayPage", corporateHoliday)
  .service("CorporateHolidayTransforms", CorporateHolidayTransforms)
  .config(corporateHolidayUrls);

export default corporateHolidayModule;



// WEBPACK FOOTER //
// ./src/pages/corporateHoliday/corporateHoliday.module.js